export default import.meta.ROLLDOWN_FILE_URL_8Hi4n$yKUsgZDE1jxHw7Dg